import React from "react";
import { IIcon } from "./icons.types";

const LocationPin: React.FC<IIcon> = ({
  width = 20,
  height = 20,
  color = "currentColor"
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.0491 4.15065C13.7006 2.82816 11.8878 2.08631 9.99909 2.08398C8.11033 2.08631 6.29758 2.82816 4.94909 4.15065C4.28745 4.80459 3.76195 5.58315 3.40293 6.44135C3.04392 7.29955 2.85851 8.22039 2.85742 9.15065C2.85742 11.3673 4.84075 14.009 6.01575 15.384C6.76575 16.2173 9.15742 18.7173 9.99909 18.7173C11.0658 18.7173 13.9658 15.384 13.9908 15.384C15.1658 14.009 17.1408 11.3757 17.1408 9.15065C17.1397 8.22039 16.9543 7.29955 16.5952 6.44135C16.2362 5.58315 15.7107 4.80459 15.0491 4.15065ZM9.99909 11.6507C9.22842 11.6507 8.48907 11.3457 7.94256 10.8023C7.39606 10.2589 7.08683 9.52131 7.08242 8.75065C7.08242 7.9771 7.38971 7.23523 7.93669 6.68825C8.48367 6.14127 9.22554 5.83398 9.99909 5.83398C10.7726 5.83398 11.5145 6.14127 12.0615 6.68825C12.6085 7.23523 12.9158 7.9771 12.9158 8.75065C12.9158 9.5242 12.6085 10.2661 12.0615 10.813C11.5145 11.36 10.7726 11.6673 9.99909 11.6673V11.6507Z"
      fill={color}
    />
  </svg>
);

export { LocationPin };
